var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 41,
    viewBox: "0 0 51 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8 17.9375V23.0625H51V17.9375H40.8ZM35.7 34.8756C38.148 36.695 41.3355 39.1037 43.86 41C44.88 39.6419 45.9 38.2581 46.92 36.9C44.3955 35.0037 41.208 32.595 38.76 30.75C37.74 32.1338 36.72 33.5175 35.7 34.8756ZM46.92 4.1C45.9 2.74187 44.88 1.35812 43.86 0C41.3355 1.89625 38.148 4.305 35.7 6.15C36.72 7.50813 37.74 8.89188 38.76 10.25C41.208 8.405 44.3955 6.02187 46.92 4.1ZM5.1 12.8125C2.295 12.8125 0 15.1187 0 17.9375V23.0625C0 25.8813 2.295 28.1875 5.1 28.1875H7.65V38.4375H12.75V28.1875H15.3L28.05 35.875V5.125L15.3 12.8125H5.1ZM34.425 20.5C34.425 17.0919 32.946 14.0169 30.6 11.9156V29.0588C32.946 26.9831 34.425 23.9081 34.425 20.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.f871438481f5bebfed99d335b79379bc.svg";
export { ForwardRef as ReactComponent };